import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "mgl-map-wrapper m-map",
  style: {
                height: '100%',
                position: 'relative',
                width: '100%',
            }
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    class: "map-wrapper m-map mapboxgl-map"
  })
], -1 /* HOISTED */)
const _hoisted_2 = { class: "o-mapInterface" }
const _hoisted_3 = { class: "o-mapInterface__topLeft" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = {
  key: 0,
  src: "/assets/images/map-sattelite.jpg",
  alt: "Sattelit",
  width: "56",
  height: "56"
}
const _hoisted_10 = {
  key: 1,
  src: "/assets/images/map-terrain.jpg",
  alt: "Terræn",
  width: "56",
  height: "56"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "o-mapInterface__bottomLeft" }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = {
  key: 0,
  class: "o-mapInterface__bottomRight"
}
const _hoisted_19 = { class: "o-mapInterface__zoom" }
const _hoisted_20 = { class: "o-mapInterface__bottom" }
const _hoisted_21 = { key: "drawn" }
const _hoisted_22 = {
  key: 0,
  ref: "listWrapper",
  class: "m-map__listWrapper"
}
const _hoisted_23 = {
  ref: "list",
  class: "m-map__list"
}
const _hoisted_24 = {
  key: 1,
  ref: "brokerListWrapper",
  class: "m-map__listWrapper"
}
const _hoisted_25 = {
  ref: "brokerList",
  class: "m-map__list"
}
const _hoisted_26 = {
  key: 'favorite',
  class: "o-favoritePreview o-favoritePreview--mobile m-map__preview"
}
const _hoisted_27 = ["textContent"]
const _hoisted_28 = ["textContent"]
const _hoisted_29 = ["textContent"]
const _hoisted_30 = {
  key: 'currentRoute',
  class: "m-map__preview o-pointOfInterestPreview o-pointOfInterestPreview--mobile"
}
const _hoisted_31 = { class: "o-pointOfInterestPreview__poiType" }
const _hoisted_32 = ["textContent"]
const _hoisted_33 = { class: "a-lead o-pointOfInterestPreview__title" }
const _hoisted_34 = ["textContent"]
const _hoisted_35 = {
  key: 0,
  class: "a-lead o-pointOfInterestPreview__distance"
}
const _hoisted_36 = {
  key: 1,
  class: "o-tags"
}
const _hoisted_37 = { class: "m-tag o-pointOfInterestPreview__tag" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = ["textContent"]
const _hoisted_40 = { class: "m-tag o-pointOfInterestPreview__tag" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = ["textContent"]
const _hoisted_43 = { class: "m-tag o-pointOfInterestPreview__tag" }
const _hoisted_44 = ["checked"]
const _hoisted_45 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_loader = _resolveComponent("m-loader")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_o_property_card = _resolveComponent("o-property-card")!
  const _component_o_broker_map_card = _resolveComponent("o-broker-map-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($props.isLoading)
          ? (_openBlock(), _createBlock(_component_m_loader, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($props.showDraw && $data.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  ($props.showPolygon)
                    ? (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        key: "buttonDeleteArea",
                        class: "m-button m-button--shadowed o-mapInterface__button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onClickRemoveArea()))
                      }, [
                        _createElementVNode("span", {
                          class: "m-button__text",
                          textContent: _toDisplayString($props.texts.removeArea)
                        }, null, 8 /* PROPS */, _hoisted_5),
                        _createVNode(_component_a_icon, {
                          class: "m-button__icon",
                          name: "delete"
                        })
                      ]))
                    : ($data.drawState !== '')
                      ? (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          key: "buttonDeleteAreaElse",
                          class: "m-button m-button--shadowed o-mapInterface__button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.onClickCloseArea()))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.close)
                          }, null, 8 /* PROPS */, _hoisted_6),
                          _createVNode(_component_a_icon, {
                            class: "m-button__icon",
                            name: "close"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          key: "buttonDrawArea",
                          class: "m-button m-button--shadowed o-mapInterface__button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.onClickDrawArea()))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.drawArea)
                          }, null, 8 /* PROPS */, _hoisted_7),
                          _createVNode(_component_a_icon, {
                            class: "m-button__icon",
                            name: "gesture"
                          })
                        ]))
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["o-mapInterface__topRight", $props.showDraw && 'o-mapInterface__topRight--searchMap'])
      }, [
        ($props.mapType === 'propertymap')
          ? (_openBlock(), _createElementBlock("button", {
              key: "buttonChangeLayout",
              type: "button",
              class: "o-mapInterface__terrainButton",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.onChangeMapLayout()))
            }, [
              _createElementVNode("span", {
                textContent: _toDisplayString(
                            $data.terrainType === 'terrain' ? 'Luftfoto' : 'Terræn'
                        )
              }, null, 8 /* PROPS */, _hoisted_8),
              ($data.terrainType === 'terrain')
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : (_openBlock(), _createElementBlock("img", _hoisted_10))
            ]))
          : _createCommentVNode("v-if", true),
        ($props.showDraw && !$data.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  ($props.showPolygon)
                    ? (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        key: "buttonDeleteArea",
                        class: "m-button m-button--shadowed o-mapInterface__button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.onClickRemoveArea()))
                      }, [
                        _createElementVNode("span", {
                          class: "m-button__text",
                          textContent: _toDisplayString($props.texts.removeArea)
                        }, null, 8 /* PROPS */, _hoisted_12),
                        _createVNode(_component_a_icon, {
                          class: "m-button__icon",
                          name: "delete"
                        })
                      ]))
                    : ($data.drawState !== '')
                      ? (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          key: "buttonDeleteAreaElse",
                          class: "m-button m-button--shadowed o-mapInterface__button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.onClickCloseArea()))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.close)
                          }, null, 8 /* PROPS */, _hoisted_13),
                          _createVNode(_component_a_icon, {
                            class: "m-button__icon",
                            name: "close"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          key: "buttonDrawArea",
                          class: "m-button m-button--shadowed o-mapInterface__button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.onClickDrawArea()))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.drawArea)
                          }, null, 8 /* PROPS */, _hoisted_14),
                          _createVNode(_component_a_icon, {
                            class: "m-button__icon",
                            name: "gesture"
                          })
                        ]))
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            ($data.drawState === 'drawing')
              ? (_openBlock(), _createElementBlock("div", {
                  key: "drawing",
                  class: "o-mapInterface__message",
                  textContent: _toDisplayString(
                            $data.isDesktop
                                ? $props.texts.helpTextDesktop
                                : $props.texts.helpTextMobile
                        )
                }, null, 8 /* PROPS */, _hoisted_16))
              : ($data.drawState === '' && $props.message)
                ? (_openBlock(), _createElementBlock("div", {
                    key: "message",
                    class: "o-mapInterface__message",
                    textContent: _toDisplayString($props.message)
                  }, null, 8 /* PROPS */, _hoisted_17))
                : _createCommentVNode("v-if", true)
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ]),
      ($props.interactive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "o-mapInterface__zoomIn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.zoomIn()))
              }, [
                _createVNode(_component_a_icon, {
                  class: "o-mapInterface__zoomIcon",
                  name: "plus"
                })
              ]),
              _createElementVNode("div", {
                class: "o-mapInterface__zoomOut",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.zoomOut()))
              }, [
                _createVNode(_component_a_icon, {
                  class: "o-mapInterface__zoomIcon",
                  name: "minimize"
                })
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            ($data.drawState === 'drawn')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "o-mapInterface__drawConfirm",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.onClickConfirmArea()))
                  }, [
                    _createVNode(_component_a_icon, { name: "search" })
                  ]),
                  _createElementVNode("button", {
                    class: "o-mapInterface__drawCancel",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.onClickDeleteArea()))
                  }, [
                    _createVNode(_component_a_icon, { name: "delete" })
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "fade",
      onEnter: $options.onEnterPreviews,
      onLeave: $options.onLeavePreviews
    }, {
      default: _withCtx(() => [
        (
                    $data.drawState === '' &&
                    !$data.isDesktop &&
                    $options.propertiesLevel >= 3 &&
                    $props.properties.some(
                        (p) => p.properties.data[0].propertyId === $data.opened,
                    )
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.properties, (property, propertyIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (property.properties.data.length > 1)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(property.properties.data, (subProperty, subPropertyIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `card-${propertyIndex}-${subPropertyIndex}`,
                            class: "m-map__listItemWrapper"
                          }, [
                            _createVNode(_component_o_property_card, {
                              ref_for: true,
                              ref: "listPropertyCards",
                              class: "m-map__listItem",
                              "data-id": 
                                        property.properties.data[0].propertyId
                                    ,
                              "data-index": 0,
                              subindex: subPropertyIndex,
                              property: subProperty,
                              "open-house-texts": {
                                        teaser: $props.texts.openHouseTeaser,
                                        teaserSignup:
                                            $props.texts.openHouseTeaserSignup,
                                    },
                              total: 
                                        property.properties.data.length > 1
                                            ? property.properties.data.length
                                            : null
                                    ,
                              onNext: _cache[11] || (_cache[11] = ($event: any) => ($options.setPreviewIndex($event))),
                              onPrev: _cache[12] || (_cache[12] = ($event: any) => ($options.setPreviewIndex($event)))
                            }, null, 8 /* PROPS */, ["data-id", "subindex", "property", "open-house-texts", "total"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("div", {
                          key: `card-${propertyIndex}`,
                          class: "m-map__listItemWrapper"
                        }, [
                          _createVNode(_component_o_property_card, {
                            ref_for: true,
                            ref: "listPropertyCards",
                            class: "m-map__listItem",
                            "data-id": 
                                        property.properties.data[0].propertyId
                                    ,
                            "data-index": 0,
                            subindex: 0,
                            property: property.properties.data[0],
                            "open-house-texts": {
                                        teaser: $props.texts.openHouseTeaser,
                                        teaserSignup:
                                            $props.texts.openHouseTeaserSignup,
                                    },
                            total: null,
                            onNext: _cache[13] || (_cache[13] = ($event: any) => ($options.setPreviewIndex($event))),
                            onPrev: _cache[14] || (_cache[14] = ($event: any) => ($options.setPreviewIndex($event)))
                          }, null, 8 /* PROPS */, ["data-id", "property", "open-house-texts"])
                        ]))
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */)
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true),
        (
                    $data.drawState === '' &&
                    !$data.isDesktop &&
                    $props.brokers.length > 0 &&
                    $props.brokers.some((b) => b.properties.data.brokerId === $data.opened)
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.brokers, (broker, brokerIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `broker-${brokerIndex}-mobile`,
                    class: "m-map__listItemWrapper"
                  }, [
                    _createVNode(_component_o_broker_map_card, {
                      ref_for: true,
                      ref: "listBrokerCards",
                      class: "m-map__listItem",
                      "data-id": broker.properties.data.brokerId,
                      data: broker.properties.data,
                      onNext: _cache[15] || (_cache[15] = ($event: any) => ($options.setPreviewIndex($event))),
                      onPrev: _cache[16] || (_cache[16] = ($event: any) => ($options.setPreviewIndex($event)))
                    }, null, 8 /* PROPS */, ["data-id", "data"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */)
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onEnter", "onLeave"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (
                    $data.drawState === '' &&
                    !$data.isDesktop &&
                    ($data.currentZoom >= 11 || $props.doFavoriteClusters) &&
                    $data.currentFavorite
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", {
                class: "a-lead o-favoritePreview__title",
                textContent: _toDisplayString($data.currentFavorite.properties.data.title)
              }, null, 8 /* PROPS */, _hoisted_27),
              _createElementVNode("p", {
                class: "a-paragraph o-favoritePreview__description",
                textContent: _toDisplayString($data.currentFavorite.properties.data.description)
              }, null, 8 /* PROPS */, _hoisted_28),
              _createElementVNode("label", {
                class: "a-label o-favoritePreview__author",
                textContent: _toDisplayString(`- ${$data.currentFavorite.properties.data.author}`)
              }, null, 8 /* PROPS */, _hoisted_29)
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (
                    ($data.drawState === '' &&
                        _ctx.currentRoutes.length > 0 &&
                        _ctx.currentRoute &&
                        _ctx.currentPoi) ||
                    ($data.drawState === '' && this.isComingSoon && _ctx.currentPoi)
                )
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Luk",
                class: "o-pointOfInterestPreview__closeButton",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($options.onPoiClose && $options.onPoiClose(...args)))
              }, [
                _createVNode(_component_a_icon, {
                  class: "m-button__icon",
                  name: "close"
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_a_icon, {
                  class: "m-button__icon",
                  name: `poi_type_${_ctx.currentPoi.typeKey}`
                }, null, 8 /* PROPS */, ["name"]),
                _createElementVNode("span", {
                  class: "a-label",
                  textContent: _toDisplayString(_ctx.currentPoi.typeName)
                }, null, 8 /* PROPS */, _hoisted_32)
              ]),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.currentPoi.poiTypeTitle), 1 /* TEXT */),
              _createElementVNode("p", {
                class: "a-label o-pointOfInterestPreview__title",
                textContent: _toDisplayString(_ctx.currentPoi.name)
              }, null, 8 /* PROPS */, _hoisted_34),
              (_ctx.currentRoutes.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(Math.round(
                            parseInt(_ctx.currentRoute.routedmeters),
                        ).toLocaleString('da-DK')) + "m ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentRoutes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _createElementVNode("input", {
                        type: "radio",
                        checked: _ctx.selectedTransportationMethod === 'foot',
                        name: "poi_direction_type",
                        value: "foot",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setSelectedTransportationMethod('foot')))
                      }, null, 8 /* PROPS */, _hoisted_38),
                      _createVNode(_component_a_icon, {
                        name: "poi_route_foot",
                        class: "m-tag__icon--unset"
                      }),
                      _createElementVNode("span", {
                        textContent: _toDisplayString(
                                `${_ctx.currentRoutes.filter((x) => x.routeType === 'foot')[0].routeTravelSeconds} min`
                            )
                      }, null, 8 /* PROPS */, _hoisted_39)
                    ]),
                    _createElementVNode("label", _hoisted_40, [
                      _createElementVNode("input", {
                        type: "radio",
                        checked: 
                                _ctx.selectedTransportationMethod === 'bicycle'
                            ,
                        name: "poi_direction_type",
                        value: "bicycle",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setSelectedTransportationMethod('bicycle')))
                      }, null, 8 /* PROPS */, _hoisted_41),
                      _createVNode(_component_a_icon, {
                        name: "poi_route_bicycle",
                        class: "m-tag__icon--unset"
                      }),
                      _createElementVNode("span", {
                        textContent: _toDisplayString(
                                `${_ctx.currentRoutes.filter((x) => x.routeType === 'bicycle')[0].routeTravelSeconds} min`
                            )
                      }, null, 8 /* PROPS */, _hoisted_42)
                    ]),
                    _createElementVNode("label", _hoisted_43, [
                      _createElementVNode("input", {
                        type: "radio",
                        checked: _ctx.selectedTransportationMethod === 'car',
                        name: "poi_direction_type",
                        value: "car",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setSelectedTransportationMethod('car')))
                      }, null, 8 /* PROPS */, _hoisted_44),
                      _createVNode(_component_a_icon, {
                        name: "poi_route_car",
                        class: "m-tag__icon--unset"
                      }),
                      _createElementVNode("span", {
                        textContent: _toDisplayString(
                                `${_ctx.currentRoutes.filter((x) => x.routeType === 'car')[0].routeTravelSeconds} min`
                            )
                      }, null, 8 /* PROPS */, _hoisted_45)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_a_icon, {
        ref: "favoriteIcon",
        name: "favorite_fill"
      }, null, 512 /* NEED_PATCH */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.poiTypes, (poiType) => {
        return (_openBlock(), _createBlock(_component_a_icon, {
          ref_for: true,
          ref: `poi_type_${poiType.key}`,
          class: "m-button__icon",
          name: `poi_type_${poiType.key}`
        }, null, 8 /* PROPS */, ["name"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */), [
      [_vShow, false]
    ])
  ]))
}